import { styled } from '@slal/ui';
import { Button } from '@slal/ui/buttons';
import { breakpointUp } from '@slal/ui/helpers';
import { ButtonProps } from './Button';

export const StyledButton = styled(Button)<ButtonProps>`
    width: auto;
    min-width: 100%;
    height: 44px;
    font-size: ${({ theme }) => theme.fontSizes[4]};
    padding: 10px 16px;
    border-radius: 4px;
    line-height: ${({ theme }) => theme.lineHeights.input};

    background-color: ${({ theme, buttonVariant }) =>
        buttonVariant === 'primary'
            ? theme.colors.blue__secondary__70
            : buttonVariant === 'secondary'
              ? theme.colors.transparent
              : theme.colors.transparent};
    border: ${({ theme, buttonVariant }) =>
        buttonVariant === 'secondary' ? `1px solid ${theme.colors.blue__secondary__80}` : 'none'}!important;
    color: ${({ theme, buttonVariant }) =>
        buttonVariant === 'primary' ? theme.colors.neutral__light__00 : theme.colors.blue__secondary__80}!important;

    &:hover {
        background-color: ${({ theme, buttonVariant }) =>
            buttonVariant === 'primary'
                ? theme.colors.blue__secondary__80
                : buttonVariant === 'secondary'
                  ? theme.colors.blue__secondary__00
                  : theme.colors.blue__secondary__10};
        border-color: ${({ theme, buttonVariant }) =>
            buttonVariant === 'secondary' ? theme.colors.blue__secondary__90 : 'none'};
        color: ${({ theme, buttonVariant }) =>
            buttonVariant === 'primary' ? theme.colors.neutral__light__00 : theme.colors.blue__secondary__90}!important;
    }

    &:active {
        background-color: ${({ theme, buttonVariant }) =>
            buttonVariant === 'primary' ? theme.colors.blue__secondary__90 : theme.colors.blue__secondary__20};
        border-color: ${({ theme, buttonVariant }) =>
            buttonVariant === 'secondary' ? theme.colors.blue__secondary__90 : 'none'};
        color: ${({ theme, buttonVariant }) =>
            buttonVariant === 'primary' ? theme.colors.neutral__light__00 : theme.colors.blue__secondary__90}!important;
    }

    &:focus {
        background-color: ${({ theme, buttonVariant }) =>
            buttonVariant === 'primary'
                ? theme.colors.blue__secondary__70
                : buttonVariant === 'secondary'
                  ? theme.colors.transparent
                  : theme.colors.transparent};
    }

    &:focus-visible {
        border: 2px solid #000000 !important;
        outline: 4px solid #26cebf;
    }

    ${breakpointUp.md`
        width:fit-content;
        min-width:auto;
    `}
`;

export const StyledButtonGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;

    ${breakpointUp.md`
        flex-direction: row;
        gap: 8px;
        width: auto;
    `}
`;
